<template>
    <activation-proposals-provider />
</template>

<script>
    import ActivationProposalsProvider from "../providers/ActivationProposalsProvider.vue";
    import ActivationProposalsView from "../data-views/activation-briefs/ActivationProposalsView.vue";

    export default {
        name: 'ActivationBriefProposalsRouterView',
        components: {
            ActivationProposalsView,
            ActivationProposalsProvider
        }
    };
</script>

<style scoped lang="scss"></style>
